module.exports = __webpack_public_path__ + "media/images/crypto-currencies/tron-66e22ef37dea33e9668d3c94c307d688.svg";